import React from "react";
import {
  FaPlus,
  FaSearch,
  FaSyncAlt,
  FaUpload,
} from "react-icons/fa";

import { AGE_LABELS } from "../data/eventOptions";

const controlClass =
  "h-11 w-full rounded-2xl border border-slate-300 bg-white px-4 text-sm text-slate-900 outline-none transition focus:border-indigo-500 focus:ring-4 focus:ring-indigo-500/10 dark:border-slate-700 dark:bg-slate-950 dark:text-white";

function SelectFilter({
  label,
  value,
  onChange,
  placeholder,
  options = [],
  className = "",
}) {
  return (
    <div className={className}>
      <label className="mb-1 block text-xs font-medium text-slate-500 dark:text-slate-400">
        {label}
      </label>

      <select
        value={value}
        onChange={(event) => onChange(event.target.value)}
        className={controlClass}
      >
        <option value="">{placeholder}</option>

        {options.map((option) => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </select>
    </div>
  );
}

export default function EventFiltersBar({
  q,
  setQ,

  disciplineEvent,
  setDisciplineEvent,

  ageCategory,
  setAgeCategory,

  organisateur,
  setOrganisateur,

  typeEvent,
  setTypeEvent,

  levelEvent,
  setLevelEvent,

  status,
  setStatus,

  dateFrom,
  setDateFrom,

  dateTo,
  setDateTo,

  allDisciplines,
  allOrganisateurs,
  allTypes,
  allLevels,

  onReset,
  onRefresh,
  onUpload,
  onCreate,

  loading,
}) {
  return (
    <section className="rounded-3xl border border-slate-200 bg-white p-4 shadow-sm dark:border-slate-800 dark:bg-slate-900">
      <div className="grid gap-3 xl:grid-cols-12">
        <div className="xl:col-span-4">
          <label className="mb-1 block text-xs font-medium text-slate-500 dark:text-slate-400">
            Recherche
          </label>

          <div className="relative">
            <FaSearch className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />

            <input
              value={q}
              onChange={(event) => setQ(event.target.value)}
              placeholder="Titre, discipline, lieu, organisateur…"
              className={`${controlClass} pl-10`}
            />
          </div>
        </div>

        <SelectFilter
          label="Discipline"
          value={disciplineEvent}
          onChange={setDisciplineEvent}
          placeholder="Toutes les disciplines"
          options={allDisciplines}
          className="xl:col-span-2"
        />

        <SelectFilter
          label="Catégorie d'âge"
          value={ageCategory}
          onChange={setAgeCategory}
          placeholder="Toutes les catégories"
          options={AGE_LABELS}
          className="xl:col-span-2"
        />

        <SelectFilter
          label="Organisateur"
          value={organisateur}
          onChange={setOrganisateur}
          placeholder="Tous les organisateurs"
          options={allOrganisateurs}
          className="xl:col-span-2"
        />

        <div className="xl:col-span-2">
          <label className="mb-1 block text-xs font-medium text-slate-500 dark:text-slate-400">
            Statut
          </label>

          <select
            value={status}
            onChange={(event) => setStatus(event.target.value)}
            className={controlClass}
          >
            <option value="all">Tous les statuts</option>
            <option value="active">Actifs</option>
            <option value="inactive">Inactifs</option>
          </select>
        </div>

        <SelectFilter
          label="Type"
          value={typeEvent}
          onChange={setTypeEvent}
          placeholder="Tous les types"
          options={allTypes}
          className="xl:col-span-2"
        />

        <SelectFilter
          label="Niveau"
          value={levelEvent}
          onChange={setLevelEvent}
          placeholder="Tous les niveaux"
          options={allLevels}
          className="xl:col-span-2"
        />

        <div className="xl:col-span-2">
          <label className="mb-1 block text-xs font-medium text-slate-500 dark:text-slate-400">
            Du
          </label>

          <input
            type="date"
            value={dateFrom}
            onChange={(event) => setDateFrom(event.target.value)}
            className={controlClass}
          />
        </div>

        <div className="xl:col-span-2">
          <label className="mb-1 block text-xs font-medium text-slate-500 dark:text-slate-400">
            Au
          </label>

          <input
            type="date"
            value={dateTo}
            onChange={(event) => setDateTo(event.target.value)}
            className={controlClass}
          />
        </div>

        <div className="flex flex-wrap items-end justify-end gap-2 xl:col-span-4">
          <button
            type="button"
            onClick={onReset}
            disabled={loading}
            className="inline-flex h-11 items-center gap-2 rounded-2xl border border-slate-300 bg-white px-4 text-sm font-medium text-slate-700 transition hover:bg-slate-50 disabled:opacity-50 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-200 dark:hover:bg-slate-800"
          >
            Réinitialiser
          </button>

          <button
            type="button"
            onClick={onRefresh}
            disabled={loading}
            className="inline-flex h-11 items-center gap-2 rounded-2xl border border-slate-300 bg-white px-4 text-sm font-medium text-slate-700 transition hover:bg-slate-50 disabled:opacity-50 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-200 dark:hover:bg-slate-800"
          >
            <FaSyncAlt className={loading ? "animate-spin" : ""} />
            Rafraîchir
          </button>

          <button
            type="button"
            onClick={onUpload}
            className="inline-flex h-11 items-center gap-2 rounded-2xl border border-indigo-300 bg-indigo-50 px-4 text-sm font-semibold text-indigo-700 transition hover:bg-indigo-100 dark:border-indigo-500/20 dark:bg-indigo-500/10 dark:text-indigo-300"
          >
            <FaUpload />
            Importer
          </button>

          <button
            type="button"
            onClick={onCreate}
            className="inline-flex h-11 items-center gap-2 rounded-2xl bg-emerald-600 px-4 text-sm font-semibold text-white transition hover:bg-emerald-700"
          >
            <FaPlus />
            Nouvel événement
          </button>
        </div>
      </div>
    </section>
  );
}